import React from 'react';
import { BsExclamationCircle } from 'react-icons/bs';
import { Box, createIcon, HStack, Icon, IconButton } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';

const ChakraIcon = createIcon({
  displayName: 'PINSAIIcon',
  viewBox: '0 0 250 250',
  path: (
    <>
      <mask height="255" id="mask0_814_352" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="250" x="0" y="0">
        <path d="M0.280273 0H249.72V254.43H0.280273V0Z" fill="none" />
      </mask>
      <g mask="url(#mask0_814_352)">
        <path d="M0.280273 0H249.72V254.43H0.280273V0Z" fill="white" />
        <path d="M0.280273 0H249.72V254.43H0.280273V0Z" fill="white" />
      </g>
      <mask height="188" id="mask1_814_352" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="189" x="27" y="33">
        <path d="M27.0723 33.9609H215.278V220.086H27.0723V33.9609Z" fill="white" />
      </mask>
      <g mask="url(#mask1_814_352)">
        <path d="M204.752 185.073C204.752 198.328 193.811 209.113 180.365 209.113H61.912C48.4572 209.113 37.5251 198.328 37.5251 185.073V68.305C37.5251 55.0416 48.4572 44.2651 61.912 44.2651H180.365C193.811 44.2651 204.752 55.0416 204.752 68.305V185.073ZM180.365 33.9609H61.912C42.6973 33.9609 27.0723 49.3636 27.0723 68.305V185.073C27.0723 204.014 42.6973 219.417 61.912 219.417H180.365C199.58 219.417 215.205 204.014 215.205 185.073V68.305C215.205 49.3636 199.58 33.9609 180.365 33.9609Z" fill="url(#aiPrimaryGradient)" />
      </g>
      <mask height="73" id="mask2_814_352" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="76" x="146" y="149">
        <path d="M146.321 149.356H221.309V221.146H146.321V149.356Z" fill="white" />
      </mask>
      <g mask="url(#mask2_814_352)">
        <mask height="74" id="mask3_814_352" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="78" x="145" y="148">
          <path d="M222.222 148.322H145.833V221.342H222.222V148.322Z" fill="white" />
        </mask>
        <g mask="url(#mask3_814_352)">
          <mask height="73" id="mask4_814_352" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="76" x="146" y="149">
            <path d="M146.321 149.356H221.309V221.146H146.321V149.356Z" fill="white" />
          </mask>
          <g mask="url(#mask4_814_352)">
            <path d="M146.321 149.356H221.426V221.146H146.321V149.356Z" fill="white" />
          </g>
        </g>
      </g>
      <path d="M119.542 154.3H79.6472L72.8112 173.482H56.499L90.6064 79.4614H108.691L142.834 173.482H126.377L119.542 154.3ZM115.165 141.75L99.6486 98.1087L84.0236 141.75H115.165Z" fill="url(#aiPrimaryGradient)" />
      <path d="M173.244 79.604V173.482H157.619V79.604H173.244Z" fill="url(#aiPrimaryGradient)" />
      <mask height="28" id="mask5_814_352" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="29" x="196" y="156">
        <path d="M196.416 156.229H224.13V183.549H196.416V156.229Z" fill="white" />
      </mask>
      <g mask="url(#mask5_814_352)">
        <path d="M224.745 170.196C214.121 172.13 212.538 173.69 210.576 184.164C208.623 173.69 207.041 172.13 196.416 170.196C207.041 168.271 208.623 166.702 210.576 156.229C212.538 166.702 214.121 168.271 224.745 170.196Z" fill="#D630E4" />
      </g>
      <mask height="28" id="mask6_814_352" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="29" x="152" y="200">
        <path d="M152.488 200.172H180.203V227.493H152.488V200.172Z" fill="white" />
      </mask>
      <g mask="url(#mask6_814_352)">
        <path d="M180.818 214.14C170.193 216.065 168.611 217.634 166.657 228.108C164.695 217.634 163.113 216.065 152.488 214.14C163.113 212.215 164.695 210.646 166.657 200.172C168.611 210.646 170.193 212.215 180.818 214.14Z" fill="#D630E4" />
      </g>
      <mask height="69" id="mask7_814_352" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="70" x="154" y="159">
        <path d="M154.216 159.643H223.507V227.947H154.216V159.643Z" fill="white" />
      </mask>
      <g mask="url(#mask7_814_352)">
        <path d="M223.018 193.559C197.221 198.238 193.369 202.036 188.622 227.466C183.865 202.036 180.013 198.238 154.216 193.559C180.013 188.87 183.865 185.082 188.613 159.643C193.369 185.082 197.221 188.87 223.018 193.559Z" fill="#D630E4" />
      </g>
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_814_352" x1="125.301" x2="133.892" y1="33.9609" y2="234.259">
          <stop stopColor="#1068D9" />
          <stop offset="0.557292" stopColor="#008EFF" />
          <stop offset="1" stopColor="#5DBAFF" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_814_352" x1="101.577" x2="106.387" y1="79.4614" y2="180.965">
          <stop stopColor="#1068D9" />
          <stop offset="0.557292" stopColor="#008EFF" />
          <stop offset="1" stopColor="#5DBAFF" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint2_linear_814_352" x1="165.777" x2="190.634" y1="79.604" y2="174.684">
          <stop stopColor="#1068D9" />
          <stop offset="0.557292" stopColor="#008EFF" />
          <stop offset="1" stopColor="#5DBAFF" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint3_linear_814_352" x1="190.139" x2="193.281" y1="159.643" y2="232.894">
          <stop stopColor="#1068D9" />
          <stop offset="0.557292" stopColor="#008EFF" />
          <stop offset="1" stopColor="#5DBAFF" />
        </linearGradient>
        <linearGradient id="aiPrimaryGradient" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stopColor="#008CFF" />
          <stop offset="38%" stopColor="#5D56FA" />
          <stop offset="53%" stopColor="#7137F1" />
          <stop offset="80%" stopColor="#A334EC" />
          <stop offset="100%" stopColor="#D630E4" />
        </linearGradient>
      </defs>
    </>
  )
});

const PINSAIIconButton = ({ iconBoxSize = 8, notification = false, error = false, ...props }) => (
  <HStack
    alignItems="flex-start"
    spacing={0}
  >
    <IconButton
      aria-label="pins-ai-icon-button"
      icon={<ChakraIcon boxSize={iconBoxSize} cursor="pointer" />}
      variant="textPrimary"
      {...props}
    />
    {error && (
      <Icon as={BsExclamationCircle} color={colors.error.primary['600']} />
    )}

    {!error && notification && (
      <Box
        backgroundColor={colors.error.primary['600']}
        borderRadius="50%"
        color="white"
        fontSize="10px"
        h="10px"
        ml="-15px"
        mt="5px"
        w="10px"
        zIndex={1}
      />
    )}
  </HStack>
);

PINSAIIconButton.propTypes = { notification: PropTypes.bool, iconBoxSize: PropTypes.number, error: PropTypes.bool };

export default PINSAIIconButton;
